import styled, { css } from 'styled-components';
import { darkgrey, white } from 'styles/Colors';

export const BatterPosition = styled.span`
  color: ${darkgrey};
`;

export const DNDWrapper = styled.span`
  position: absolute;
  right: 60px;
  cursor: move;
`;

export const Controls = styled.span`
  flex: 1;
  margin-top: -2px;
  ${BatterPosition} {
    text-transform: uppercase;
    font-family: 'Oswald';
    font-size: 15px;
    font-weight: 500;
    letter-spacing: 0.42px;
    position: relative;
    top: -2px;
    left: 5px;
  }
  ${BatterPosition} {
    float: right;
  }
  svg {
    position: relative;
    float: right;
    bottom: 6px;
    margin-left: 10px;
  }
  .jersey-number {
    position: absolute;
    right: 95px;
    top: 8px;
  }
`;

export const TaggingLineupPlayerWrapper = styled.div<{ current?: boolean }>`
  overflow: hidden;
  display: flex;
  margin-top: 10px;
  font-family: 'Lato';
  font-size: 13px;
  height: 36px;
  letter-spacing: 0.5px;
  color: ${darkgrey};
  padding: 8px 7px;
  font-weight: bold;
  background-color: ${white};
  cursor: pointer;
  &.disabled {
    color: rgba(65, 65, 65, 0.5);

    ${BatterPosition} {
      color: rgba(65, 65, 65, 0.5);
    }
    svg {
      path {
        fill: rgba(65, 65, 65, 0.5);
      }
    }
    ${(props) =>
      props.current &&
      css`
        background-image: none;
        background-color: rgba(5, 125, 255, 0.5);
      `}
  }
  &.pitcher {
    margin-bottom: 10px;
    .name {
      flex: 2;
    }
  }
  ${(props) =>
    props.current &&
    css`
      background-image: linear-gradient(273deg, #449fff, #057dff);
      border-radius: 5px;
      color: ${white} !important;
      svg {
        path {
          fill: ${white} !important;
        }
      }
      ${BatterPosition} {
        color: ${white} !important;
      }
    `}
`;

export const Name = styled.span`
  flex: 1;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;
